module.exports = __webpack_public_path__ + "static/tat-46-6f2a1b2a5f076e00dff2e88bb8e1f480.jpg";